var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 26,
    viewBox: "0 0 23 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_38_12811",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 23,
    height: 26
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.988647 0H22.0114V26H0.988647V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_38_12811)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.0751 19.4513C14.4452 19.7436 11.2516 18.5937 8.79241 19.7436C11.9347 17.4048 20.0808 21.0105 21.4129 14.0135C18.1681 17.6582 13.0448 15.9041 8.67287 18.2429C3.61783 20.952 6.28197 26.3898 11.5761 25.9805C10.5856 25.805 8.00683 24.1874 8.60455 22.7061C9.7146 19.8801 15.3844 22.3553 17.0751 19.4513ZM21.9594 8.63418C20.6103 13.1559 14.9916 13.6237 12.1396 14.7736C13.745 13.6822 17.9973 12.5322 19.9954 9.95953C21.0884 8.53673 21.6008 6.23689 20.3882 4.19041C20.0125 7.56222 17.1093 10.7391 13.8987 12.2594C17.5704 10.1349 20.9006 2.76761 16.7507 0C17.1605 5.28185 13.1302 11.8696 6.50397 17.1125C6.12826 17.4048 5.46223 18.0285 5.24023 18.4963C5.30854 17.7751 6.36734 16.8396 6.67476 16.5472C4.67665 16.937 2.16622 15.5337 1.73927 17.6582C2.08083 17.6777 2.42238 17.8141 2.71271 18.048C2.14914 17.7946 0.782913 17.6972 0.987847 18.8081C1.10739 18.4963 1.51726 18.4573 1.9442 18.5352C4.19847 19.0225 3.87399 20.8156 5.25729 21.985C5.35977 20.036 6.89678 18.6132 8.45085 17.7361C13.1131 15.1439 22.8304 17.015 21.9594 8.63418Z",
    fill: "url(#paint0_linear_38_12811)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_38_12811",
    x1: 30.0085,
    y1: 4.16,
    x2: -4.81264,
    y2: 14.2243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B57E10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1507,
    stopColor: "#B57E10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4638,
    stopColor: "#E5C35C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6129,
    stopColor: "#F9DF7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7204,
    stopColor: "#FFF3A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8387,
    stopColor: "#F9DF7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B57E10"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.a94c1fd95f38aba447c85139cb730f60.svg";
export { ForwardRef as ReactComponent };